<template>
  <div class="box">
    <div class="top">
      <div class="top_todolist">
        <div class="top_title_dv">
          <div class="top_title_icon">
            <span class="el-icon-alarm-clock clock"></span>
            &nbsp;
            <span style="color:#f8ab01;font-weight:bold;font-size:18px">To Do List</span>
          </div>
          <div class="top_more" @click="getMore">
            <span>More</span>
          </div>
        </div>
        <el-table :data="todolists" style="width: 100%" :show-header="false" max-height="354px">
          <el-table-column width="80">
            <template>
              <div class="icon">
                <span class="icon-daibanshixiang1"></span>
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="workflowDesc">
            <template slot-scope="scope">
              <div class="item_lf">
                <el-tooltip class="item" effect="dark" :content="scope.row.workflowDesc" placement="top">
                  <p class="item_content" @click="detailClick(scope.row.taskType,scope.row.bizId,scope.row)">
                    {{scope.row.workflowDesc}}
                  </p>
                </el-tooltip>
                <p class="item_info">
                  <span>{{'No:&nbsp;'+scope.row.bizNo}}</span>
                  <span>{{'Creator:&nbsp;'}}{{+scope.row.creatorName===null?'':scope.row.creatorName}}</span>
                  <span>{{'Create Date:&nbsp;'+scope.row.createDate.split('.')[0]}}</span>
                </p>
              </div>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div class="top_echart">
        <div class="top_echart_dv">
          <span class="el-icon-pie-chart chart"></span>
          &nbsp;
          <span style="font-weight:bold;font-size:18px">FPA - Capital Distribution</span>
        </div>
        <div class="myChart" id="myChart" ref="Echart"></div>
        <p class="top_echart_tip">*All food categories as of current year</p>
      </div>
    </div>
    <div class="bottom">
      <div class="chart_info">
        <div class="chart_info_lf">
          <span class="el-icon-s-data data"></span>
          &nbsp;
          <span style="color:#f8ab01;font-weight:bold;font-size:18px">Statistics</span>
        </div>
        <div class="chart_info_rg">
          <div class="task">
            <span>Task: </span>
            &nbsp;
            <ic-select clearable table="DASHBOARD" field="TASK_TYPE" v-model="taskType" @change="taskChange(taskType)" style="display:inline-block" :placeholder="$t('BC.sel')"></ic-select>
          </div>
          <div>
            <span>Status: </span>
            &nbsp;
            <ic-select clearable table="DASHBOARD" field="TASK_STATUS" v-model="taskStatus" @change="statusChange(taskStatus)" style="display:inline-block" :placeholder="$t('BC.sel')"></ic-select>
          </div>
        </div>
      </div>
      <div class="barChart" id="barChart" ref="Echart"></div>
    </div>
  </div>
</template>
<script>
import taskApi from "../../../api/myTask";
import IcSelect from "@/components/common/icSelect";
import commonFun from "@/utils/commonFun";

var color = [
  // 'rgb(225,204,209)',
  'rgb(240,235,231)',
  'rgb(194,203,218)',
  'rgb(205,195,186)',
  'rgb(192,190,191)',
  'rgb(162,126,130)',
  'rgb(252,234,214)',
  'rgb(136,149,168)',
  'rgb(151,163,141)',
]
export default {
  components: {
    IcSelect
  },
  data() {
    return {
      todolists: [],
      taskType: "",
      taskStatus: "",
      count: 0,//起始页数值为0
      loading: false,
      totalPages: "7",//取后端返回内容的总页数
      pieData: [],
      obj: {
        monthData: [],
        countData: []
      },
      nameData: [],
      valueLists: [],
      // params: {
      //   pageNum: 1,
      //   pageSize: 6
      // }
    }
  },
  created() {
    this.getToDoLists(this.params)
    this.getPieData()
    this.getBarData()
  },
  watch: {
    pieData(val, oldVal) {
      this.$nextTick(() => {
        this.drawCharts(val)
      })
    },
    obj: {
      handler(newV) {
        if (newV.monthData.length > 0 && newV.countData.length > 0) {
          this.$nextTick(() => {
            this.drawBarCharts(newV)
          })
        }
      },
      deep: true
    },
  },
  mounted() {
    const self = this
    setTimeout(() => {
      window.addEventListener('resize', function () {
        self.chart = self.$echarts.init(self.$refs.Echart)
        self.chart.resize()
      })
    }, 200);
  },
  methods: {
    detailClick(taskType, bizId, row) {
      console.log('taskType', taskType);
      var that = this;
      let taskName = row.taskName;
      if (commonFun.isNotEmpty(row.auditPath)) {
        this.$router.push({ path: row.auditPath, query: { id: bizId } });
      }
      switch (taskType) {
        //供应商报价
        case "QUOTATION":
          if (row.bizNo.startsWith('PX')) {
            that.$router.push({ path: `/inquiry-quotation-product-sp-detail`, query: { roundId: bizId } });
          } else {
            that.$router.push({ path: `/quotation-sp-detail/${bizId}` });
          }
          break;
        //MSV审核
        case "MSV":
          if (taskName == "审核中") {
            that.$router.push({ path: `/visitReportAudit`, query: { ttMsvReportId: bizId } });
          } else {
            that.$router.push({ path: `/visitReport-add`, query: { ttMsvReportId: bizId } });
          }
          break;
        //Sensory报告模板审批
        case "SENSORY_REPORT":
          this.$router.push({
            path: `/sensoryTemplate-add`,
            query: { ttSensoryTemplateId: bizId, taskApproval: true },
          });
          break;
        //按线路报价价格确认流程
        case "LINE_SOURCING":
          this.$router.push({ name: "auditSourcing", query: { sourcingId: bizId } });
          // that.auditDialog = true;
          break;
        //按产品报价价格确认流程:/auditLineSourcing
        case "PRODUCT_SOURCING":
          this.$router.push({ name: "auditProSourcing", query: { sourcingId: bizId } });
          // that.proAuditDialog = true;
          break;
        //问题报告处理
        case "PROBLEM_REPORT_HANDLE":
          switch (taskName) {
            case '调查报告待提交':
              that.$router.push({ name: `feedbackReportView`, query: { feedbackReportId: bizId } });
              break;
            case '问题报告驳回':
              that.$router.push({ name: "feedbackReportView", query: { action: 'audit', feedbackReportId: bizId } });
              break;
            case 'MCD处理':
              that.$router.push({ path: `/feedbackReport/approve`, query: { feedbackReportId: bizId } });
              break;
            case '质量反馈中心处理':
              that.$router.push({ path: `/feedbackReport/approve`, query: { feedbackReportId: bizId } });
              break;
            case '质量反馈中心处理疑问反馈':
              that.$router.push({ path: `/feedbackReportQuestion-detail`, query: { feedbackReportId: bizId } });
              break;
            default:
              that.$router.push({ name: "feedbackReportView", query: { action: 'audit', feedbackReportId: bizId } });
          }
          break;
        //质量反馈
        case "STORE_FEEDBACK":
          this.$router.push({
            path: `/storeFeedback-detail`,
            query: {
              feedbackId: bizId
            }
          });
          break;
        //产能调查
        case "CAPACITY":
          this.$router.push({
            path: `/capacityDetail`,
            query: { ttCapacityId: bizId },
          });
          break;
        //FPA_PERMANENT
        case "FPA_PERMANENT":
          this.$router.push({
            name: 'fpaPermanentDetail',
            params: { ttFpaId: bizId, isCopy: 'N' }
          });
          break;
        //FPA_LTO_CAMPAIGN
        case "FPA_LTO_CAMPAIGN":
          this.$router.push({
            name: 'fpaLtoCampaignDetail',
            params: { ttFpaLtoCampaignId: bizId }
          });
          break;
        //FPA_LTO
        case "FPA_LTO":
          this.$router.push({
            name: 'fpaLtoDetail',
            params: { ttFpaLtoId: bizId }
          });
          break;
      }
    },
    taskChange(val) {
      this.getBarData()
    },
    statusChange(val) {
      this.getBarData()
    },
    getToDoLists() {
      taskApi.myTasklist({}).then((res) => {
        if (res.code === '200') {
          this.todolists = res.data.records
        }
      });
    },
    getMore() {
      this.$router.push('/mytask')
    },
    getPieData() {
      taskApi.getPieData().then(res => {
        if (res.code === '200') {
          this.pieData = res.data
          res.data.forEach(ele => {
            this.nameData.push(ele.name)
            this.valueLists.push(ele.value)
          })
          var maxObj = this.pieData.reduce(function (max, obj) {
            // console.log('obj',obj);
            // console.log('max',max);
            return Number(obj.value) > Number(max.value) ? obj : max;
          });
          console.log('maxObj', maxObj);
          this.pieData.forEach(ele => {
            if (ele.name == maxObj.name) {
              ele.itemStyle = {
                normal: {
                  color: "#E1CCD1"
                }
              }
            }
          })
        }
      })
    },
    getBarData() {
      var params = {
        taskType: this.taskType,
        taskStatus: this.taskStatus
      }
      this.obj.monthData = []
      this.obj.countData = []
      taskApi.getBarData(params).then(res => {
        if (res.code === '200') {
          res.data.forEach(ele => {
            this.obj.monthData.push(ele.monthDes)
            this.obj.countData.push(ele.count)
          })
        }
      })
    },
    drawCharts(val) {
      // 基于准备好的dom，初始化echarts实例
      let myChart = this.$echarts.init(document.getElementById('myChart'))
      // 绘制图表
      var option = {
        tooltip: {
          trigger: 'item',
          formatter: '{b}:{c}(M)\n({d}%)'
        },
        legend: {
          itemWidth: 12,
          itemHeight: 12,
          orient: 'vertical',
          left: '20px',
          top: "center",
          data: this.pieData,
          // selectedMode: false,//是否可点击,但是会把点击和hover事件同时注销
          tooltip: {
            show: true,
            trigger: "item",
            formatter: function (val) {
              // 获取legend显示内容
              let data = option.series[0].data;
              let total = 0;
              let tarValue = 0;
              for (let i = 0, l = data.length; i < l; i++) {
                total += Number(data[i].value);
                if (data[i].name == val.name) {
                  tarValue = data[i].value;
                }
              }
              let p = (tarValue / total * 100).toFixed(2);
              return val.name + ' ' + tarValue + '(M)(' + p + '%)';
            }
          },
          textStyle: {
            fontSize: 12
          },

        },
        series: [
          {
            // name: 'FPA-Capital Distruction',
            type: 'pie',
            color: color,
            radius: ['50%', '90%'],//饼图大小
            avoidLabelOverlap: false,
            itemStyle: {
              borderRadius: 10,
              // borderColor: '#fff',
              borderWidth: 2,
              emphasis: {
                shadowBlur: 10,
                shadowOffsetX: 0,
                shadowColor: 'rgba(0,0,0,0.5)'
              }
            },
            center: ['58%', '50%'],//图的位置，距离左跟上的位置
            data: val,
            emphasis: {
              label: {
                show: false,
              }
            },
            label: {
              show: false,
            },
            //延长线
            labelLine: {
              show: false
            },
          }
        ]
      }
      myChart.on('legendselectchanged', function (res) {
        console.log('reee', res);
        console.log('option', option);
        // res.selected[res.name] = false;//相当于取消点击事件
        myChart.setOption({
          legend: {
            selected: {
              [res.name]: true
            }
          }
        })
      })
      myChart.setOption(option);
      setTimeout(() => {
        window.onresize = function () {
          myChart.resize()
        }
      }, 200);
    },
    drawBarCharts(obj) {
      // 基于准备好的dom，初始化echarts实例
      let barChart = this.$echarts.init(document.getElementById('barChart'))
      // 绘制图表
      barChart.setOption({
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'shadow'
          }
        },
        grid: {
          left: '3%',
          right: '4%',
          bottom: '3%',
          containLabel: true
        },
        xAxis: [
          {
            type: 'category',
            data: obj.monthData,
            axisTick: {
              alignWithLabel: true
            }
          }
        ],
        yAxis: [
          {
            type: 'value'
          }
        ],
        series: [
          {
            name: 'Direct',
            color: '#C8C0D5',
            type: 'bar',
            barWidth: '40%',
            data: obj.countData
          }
        ]
      });
    },
  }
}
</script>
<style lang="scss" scoped>
.box {
  width: 96%;
  height: calc(100% - 42px);
  padding: 10px 2%;
  display: flex;
  flex-direction: column;
  .top {
    width: 100%;
    height: 55%;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    .top_todolist {
      width: 60%;
      margin-right: 20px;
      background-color: #fff;
      border-radius: 10px;
      box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.35);
      display: flex;
      flex-direction: column;
      .top_title_dv {
        height: 35px;
        // line-height: 35px;
        border-bottom: 1px solid #eee;
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        align-items: center;
        padding: 5px 10px 0 10px;
        z-index: 100;
        .top_title_icon {
          .clock {
            color: #f8ab01;
            // vertical-align: sub;
          }
        }
        .top_more {
          cursor: pointer;
        }
      }
      .item_lf {
        flex: 1;
        height: 50px;
        line-height: 50px;
        display: flex;
        flex-direction: column;
        align-content: center;
        text-align: left;
        .item_content,
        .item_info {
          padding: 0;
          width: 100%;
          height: 25px;
          line-height: 25px;
        }
        .item_content {
          cursor: pointer;
          overflow: hidden;
          white-space: nowrap;
          text-overflow: ellipsis;
        }
        .item_info {
          span {
            display: inline-block;
            margin-right: 30px;
            width: 33%;
          }
        }
      }
    }
    .top_echart {
      flex: 1;
      border: 1px solid #fff;
      background-color: #fff;
      border-radius: 10px;
      box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.35);
      width: 100%;
      display: flex;
      flex-direction: column;
      .top_echart_dv {
        height: 35px;
        line-height: 35px;
        border-bottom: 1px solid #eee;
        color: #f8ab01;
        padding: 0 10px;
        margin-top: 5px;
        .chart {
          color: #f8ab01;
          // vertical-align: sub;
        }
      }
      .top_echart_tip {
        text-align: right;
        height: 15px;
        line-height: 15px;
        padding-right: 20px;
        color: #f8ab01;
        padding-bottom: 10px;
      }
      .myChart {
        width: 100%;
        flex: 1;
      }
    }
  }
  .bottom {
    flex: 1;
    margin: 20px 0 10px 0;
    border-radius: 10px;
    box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.35);
    border: 1px solid #fff;
    background-color: #fff;
    display: flex;
    flex-direction: column;
    align-content: center;
    .chart_info {
      height: 40px;
      display: flex;
      justify-content: space-between;
      flex-direction: row;
      border-bottom: 1px solid #eee;
      padding:5px 10px 0 10px;
      .chart_info_lf {
        height: 40px;
        line-height: 40px;
        .data {
          color: #f8ab01;
          font-size: 24px;
          // vertical-align: sub;
        }
      }
      .chart_info_rg {
        height: 40px;
        line-height: 40px;
        display: flex;
        justify-content: space-between;
        flex-direction: row;
        .task {
          margin-right: 30px;
        }
      }
    }
    .barChart {
      flex: 1;
    }
  }
}
</style>